import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=c26b7ffa&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26b7ffa",
  null
  
)

export default component.exports